import { render, staticRenderFns } from "./TabRelationContacts.vue?vue&type=template&id=6ec6c3ac"
import script from "./TabRelationContacts.vue?vue&type=script&setup=true&lang=js"
export * from "./TabRelationContacts.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports